import { FC, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useFetchRateCardsConfigsQuery } from "../../../../redux/queries"
import { Brand } from "../../../../types"
import { useBrandSearchParam } from "../../../hooks"
import ConfigListShell from "../config-list-shell"
import RateCardsConfigTable from "./table"
import { PrimaryBtn } from "../../buttons"

interface Props {
  brands: Brand[]
}

const ConfigRateCards: FC<Props> = ({ brands }) => {
  const navigate = useNavigate()
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()

  const { data: configs, isFetching: isFetchingConfigs } =
    useFetchRateCardsConfigsQuery(
      { brand_id: selectedBrandId },
      { skip: !selectedBrandId }
    )

  const goToEdit = useCallback(
    (configId: string) => {
      navigate(`/config-admin/rate-cards/${configId}`)
    },
    [navigate]
  )

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
      actions={
        selectedBrandId ? (
          <PrimaryBtn
            onClick={() =>
              navigate(
                `/config-admin/rate-cards/new?brand_id=${selectedBrandId}`
              )
            }
          >
            + Rate Cards Config
          </PrimaryBtn>
        ) : null
      }
    >
      {selectedBrandId ? (
        <RateCardsConfigTable
          data={configs ?? []}
          brands={brands}
          isFetching={isFetchingConfigs}
          onSelect={goToEdit}
        />
      ) : null}
    </ConfigListShell>
  )
}

export default ConfigRateCards
